import { render, staticRenderFns } from "./UserLoginCodesComponent.vue?vue&type=template&id=3d4705e6&"
import script from "./UserLoginCodesComponent.vue?vue&type=script&lang=js&"
export * from "./UserLoginCodesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports